export default "__VITE_ASSET__BCJVvvPo__"